"use client"

import { Volume1 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Volume1Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Volume1Icon = component(Icon)({ as: Volume1 })
